import { useTranslation } from 'react-i18next';
import { TEMPLATE_READINESS } from '@lims/shared-types';
import { Alert } from '../../components/ui/index.js';

/**
 * THE READINESS BANNER — `CLAUDE.md` section 4, and requirements p.23.
 *
 * Shown wherever a result is entered or read, for a test that has no certified
 * specialised template: one short statement and what can be recorded. A
 * not-ready test is never presented with invented scientific fields, and this
 * banner is the statement of why there are none. A ready test needs no banner.
 */
export function ReadinessBanner({ readiness }: { readonly readiness: string }) {
  const { t } = useTranslation();
  if (readiness === TEMPLATE_READINESS.READY) return null;

  return (
    <div data-testid="readiness-banner">
      <Alert
        tone="warning"
        title={t('attempt.readinessTitle')}
        description={t('attempt.readinessNotReadyBody')}
      />
    </div>
  );
}
